import {
  fetchMyProfile,
  getUser,
  isSupabaseConfigured,
} from '@bangle.io/supabase';

/** Build the `created_by` display string stamped into new notes. */
export function formatCreatedByLabel(input: {
  displayName?: string | null;
  email?: string | null;
}): string | undefined {
  const name =
    typeof input.displayName === 'string'
      ? input.displayName.trim() || undefined
      : undefined;
  const email =
    typeof input.email === 'string' ? input.email.trim() || undefined : undefined;
  if (name && email) {
    return `${name} <${email}>`;
  }
  return name ?? email;
}

/** Markdown seed for a brand-new note, or empty string when there is no author. */
export function noteSeedWithCreatedBy(createdBy: string | undefined): string {
  if (!createdBy) {
    return '';
  }
  // JSON string quoting is always valid YAML for a scalar.
  return `---\ncreated_by: ${JSON.stringify(createdBy)}\n---\n\n`;
}

/** Best-effort author label for the current session; undefined when offline/anonymous. */
export async function resolveCreatedByLabel(): Promise<string | undefined> {
  try {
    if (!isSupabaseConfigured()) {
      return undefined;
    }
    const user = await getUser();
    if (!user) {
      return undefined;
    }
    const profile = await fetchMyProfile().catch(() => null);
    const metaName =
      typeof user.user_metadata?.display_name === 'string'
        ? user.user_metadata.display_name
        : undefined;
    return formatCreatedByLabel({
      displayName: profile?.display_name || metaName,
      email: profile?.email || user.email,
    });
  } catch {
    return undefined;
  }
}
